<template>
  <div class="footer">
    <div class="footer-main">
      <div class="footer-nav">
        <li v-for="(item,index) in downNav" :key="index" @click="gotop" >
          <router-link :to="{path: '/helpCenter/startUse',query: {id: item.id}}">
            {{item.name}}
          </router-link>
        </li>
        <li>
          <router-link to="/agency">
            Affiliate
          </router-link>  
        </li>
      </div>

      <div class="footer-slice">
        <div class="footer-payment">
          <h5>SUPPORT PAYMENT</h5>
          <img src="./img/PhonePe.svg" alt="">
          <img src="./img/BankTransfer.svg" alt="">
          <img src="./img/paytm.svg" alt="">
          <img src="./img/BHIM.svg" alt="">
          <img src="./img/Skrill.svg" alt="">
          <img src="./img/Neteller.svg" alt="">
          <img src="./img/AmazonPay.svg" alt="">
          <img src="./img/GooglePay.svg" alt="">
        </div>
        <div class="footer-licenses">
          <h5>LICENCES</h5>
          <img src="./img/GC.svg" alt="">
          <!-- <img src="./img/PAGCOR.svg" alt=""> -->
          <img src="./img/18+.svg" alt="">
        </div>
        <div class="footer-app">
          <h5>{{ $t('footer.Certificates')}}</h5>
          <img src="./img/AppStore.svg" alt="">
          <img src="./img/downloadandroid.svg" alt="">
        </div>
      </div>
      <div class="footer-copy">{{ $t('footer.copyBrand',{year:new Date().getFullYear()}) }}</div>
    </div>
    <!-- 下载弹窗 -->
    <appDownload ref="appdown"/>
    
  </div>
</template>

<script>
  import appDownload from "../common/appDownload.vue";
  import { fixedTextList,footerNav,topNavList} from '../common/comdata.js'
  import { mapState, mapMutations,mapActions} from 'vuex'
  import { common,commonApi } from '@/common/index'
  export default {
    data() {
      return {
        footerNav,
        fixedTextList,
        topNavList,
        curIndex: 0,
        value: '',
        yhPcLiveChatList:'',
        yhPcWhatsappList:'',
      }
    },
    components: { appDownload },
    computed: {
      ...mapState({
        customer_service_system_link: state => state.FrontConfigList.customer_service_system_link,
        downNav: state => state.downNav,
        customer_service_QQ: state => state.FrontConfigList.customer_service_QQ,
        contact_email: state => state.FrontConfigList.contact_email,
        agent_url: (state) =>state.FrontConfigList.agent_url,    //代理链接
        live_chat: state => state.FrontConfigList.live_chat,
        whatsapp: state => state.FrontConfigList.whatsapp,
        appDownload: state => state.linkList.appDownload,
      }),
    },
    methods: {
      handleGoPage({ url }){
        return this.$router.push({ path:url })
      },
      handleGODown(){  // ios android 下载
        // window.open(this.appDownload)
        this.$refs.appdown.dialogDown = !this.$refs.appdown.dialogDown
      },
      gotop(){
        document.getElementById("app").scrollTop = 0;
      },
      fetchImg() {
        let imgCodes = ['pcLiveChat','pcWhatsApp'].join(',')
        commonApi.HOMEBEFORE.fetchImgs(imgCodes)
        .then((data)=>{
          this.yhPcLiveChatList = data.pcLiveChat;
          this.yhPcWhatsappList = data.pcWhatsApp;
        })
      },
      ...mapActions(['getArticleType']),
      ...mapMutations(["setshowloginfloat",]),
    },
    mounted() {
      this.getArticleType()
      this.fetchImg()
    }
  }
</script>

<style scoped lang="scss">
@import '../../style/mixins';
  .footer {
    width:100%;
    z-index:2;
    position: relative;
    background: #211F1B;
    .footer-main{
      color: #333;
      @include main-container ;
      .footer-nav{
        li {
            display: inline-block;
            font-weight: 400;
            font-size: 12px;
            margin-right: 30px;
            padding:20px 0;
            a {
                color: #7f7f7f;
                text-decoration: none;
            }
        }
      }
      .footer-slice {
        display: flex;
        color: white;
        justify-content: space-between;
          h5{
            margin:20px 0;
          }
          img {
              display: inline-block;
              height: 34px;
              width: auto;
              margin-right: 10px;
          }
      }
      .footer-copy{
        border-top: 1px solid #2d2d2d;
        padding: 20px 0;
        margin-top: 20px;
        font-size: 10px;
        color: white;
        font-weight: 400;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/build902/components/footer/footer.vue